import React, { useCallback, useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { DeckNav } from './DeckNav';
import { DECK_UNLOCK_STORAGE_KEY, EmailGate } from './EmailGate';
import { SlideView } from './SlideView';
import { slides } from './slides';
export function Deck() {
  const [index, setIndex] = useState(0);
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [isGateOpen, setIsGateOpen] = useState(false);
  const total = slides.length;
  useEffect(() => {
    setIsUnlocked(localStorage.getItem(DECK_UNLOCK_STORAGE_KEY) === 'true');
  }, []);
  const goTo = useCallback((requestedIndex: number) => {
    const nextIndex = Math.max(0, Math.min(total - 1, requestedIndex));
    if (nextIndex === index) return;
    if (!isUnlocked && nextIndex > 0) {
      setIsGateOpen(true);
      return;
    }
    setIndex(nextIndex);
  }, [index, isUnlocked, total]);
  const next = useCallback(() => goTo(index + 1), [goTo, index]);
  const prev = useCallback(() => goTo(index - 1), [goTo, index]);
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (isGateOpen) {
        if (event.key === 'Escape') setIsGateOpen(false);
        return;
      }
      if (event.key === 'ArrowRight' || event.key === 'PageDown') next();else if (event.key === 'ArrowLeft' || event.key === 'PageUp') prev();else if (event.key === 'Home') goTo(0);else if (event.key === 'End') goTo(total - 1);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isGateOpen, next, prev, goTo, total]);
  const handleUnlock = () => {
    setIsUnlocked(true);
    setIsGateOpen(false);
    setIndex(1);
  };
  const slide = slides[index];
  return <main className="relative flex min-h-screen w-full flex-col bg-bg" data-id="element-1" data-mp="nfcrg471ajgt">
      <header className="pointer-events-none fixed inset-x-0 top-0 z-20 flex items-center justify-between px-5 py-5 sm:px-8" data-id="element-2" data-mp="1k0mqcglv9iw3">
        <div className="flex items-center gap-2.5" data-id="element-3" data-mp="1f6ikk0oc7gwl">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent/15 ring-1 ring-accent/30" data-id="element-4" data-mp="39h8kwodb1ri4">
            <span className="h-3 w-3 rounded-sm bg-accent" data-id="element-5" data-mp="3eeqxcoqj6ouv" />
          </span>
          <span className="text-sm font-bold tracking-tight text-white" data-id="element-6" data-mp="2zpcm1b3e9xcu">
            Open<span className="text-accent" data-id="element-7" data-mp="34oyy3h7hl7k2">FPGA</span>
          </span>
        </div>
        <span className="hidden font-mono text-xs uppercase tracking-[0.2em] text-slate-500 sm:block" data-id="element-8" data-mp="2qppjun2ucniq">
          Seed Deck · 2026
        </span>
      </header>

      <div aria-hidden className="pointer-events-none fixed inset-0 opacity-[0.4]" style={{
      backgroundImage: 'radial-gradient(circle at 50% 0%, rgba(45,212,167,0.05), transparent 55%)'
    }} data-id="element-9" data-mp="2vqdhvsphm4mg" />

      <div className="flex flex-1 items-center pb-24 pt-16" data-id="element-10" data-mp="f0euzmq1r4zv">
        <AnimatePresence mode="wait" data-id="element-11" data-mp="ey2d19kagumt">
          <SlideView key={slide.id} slide={slide} index={index} data-id="element-12" data-mp="jzrpmtn5tgd0" />
        </AnimatePresence>
      </div>

      <DeckNav slides={slides} index={index} onPrev={prev} onNext={next} onGoTo={goTo} data-id="element-13" data-mp="24gr66pqy44p6" />

      <EmailGate isOpen={isGateOpen} onClose={() => setIsGateOpen(false)} onUnlock={handleUnlock} data-id="element-14" data-mp="1zjsbo63ddvqg" />
    </main>;
}